import React from "react";
import {
  Search,
  Calendar,
  Users,
  Utensils,
  ArrowRight,
  Plus,
  RotateCcw,
  Settings,
  Users as UsersIcon,
  Edit,
  Mail,
  Link,
  CreditCard,
  ShoppingBag,
  History
} from "lucide-react";

export type TabIconTypes =
  | "search"
  | "bookings"
  | "waitlist"
  | "open"
  | "left"
  | "add"
  | "sync"
  | "manage"
  | "guests"
  | "preorders"
  | "payments"
  | "notes"
  | "messages"
  | "linked"
  | "history";
type TabIconProps = {
  name: TabIconTypes;
};

export function TabIcon({ name }: TabIconProps) {
  const getIcon = () => {
    switch (name) {
      case "search":
        return <Search />;
      case "bookings":
        return <Calendar />;
      case "waitlist":
        return <Users />;
      case "open":
        return <Utensils />;
      case "left":
        return <ArrowRight />;
      case "add":
        return <Plus />;
      case "sync":
        return <RotateCcw />;
      case "manage":
        return <Settings />;
      case "guests":
        return <UsersIcon />;
      case "preorders":
        return <ShoppingBag />;
      case "payments":
        return <CreditCard />;
      case "notes":
        return <Edit />;
      case "messages":
        return <Mail />;
      case "linked":
        return <Link />;
      case "history":
        return <History />;
      default:
        return <Calendar />;
    }
  };

  return (
    <div className="TabIcon text-center mx-auto p-1.5 h-8">
      <div className="TabIcon_Item TabIcon_FluentIcon flex items-center justify-center h-5 [&>svg]:w-5 [&>svg]:h-5 [&>svg]:fill-none [&>svg]:stroke-current [&>svg]:stroke-2">
        {getIcon()}
      </div>
    </div>
  );
}
